import { useMemo, useState } from 'react';
import type { AbilityDemo } from './types';

function scrollToSlug(slug: string) {
  const el = document.getElementById(slug);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  el.classList.add('ability-flash');
  setTimeout(() => el.classList.remove('ability-flash'), 1400);
}

export function AbilityJumpNav({ demos }: { demos: AbilityDemo[] }) {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return demos;
    return demos.filter((d) => d.label.toLowerCase().includes(q));
  }, [demos, query]);

  return (
    <div className="card mb-3 space-y-2">
      <div className="flex items-center gap-2">
        <div className="font-display text-[11px] uppercase tracking-[0.24em] text-gold-400">
          Jump to ability
        </div>
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="filter…"
          aria-label="Filter abilities"
          className="input-base ml-auto h-7 w-32 py-0 text-xs"
        />
        <select
          aria-label="Jump to ability"
          className="input-base h-7 w-auto py-0 text-xs"
          value=""
          onChange={(e) => {
            if (e.target.value) scrollToSlug(e.target.value);
            e.currentTarget.blur();
          }}
        >
          <option value="">⇳ jump…</option>
          {demos.map((d) => (
            <option key={d.slug} value={d.slug}>
              {d.label}
            </option>
          ))}
        </select>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {filtered.map((d) => (
          <button
            key={d.slug}
            type="button"
            onClick={() => scrollToSlug(d.slug)}
            className="rounded-sm border border-gold-400/25 bg-ink-800/50 px-2 py-0.5 text-[11px] text-parchment-100/85 hover:border-gold-400/60 hover:text-gold-300"
          >
            {d.label}
          </button>
        ))}
        {filtered.length === 0 && (
          <span className="text-xs muted italic">no match</span>
        )}
      </div>
    </div>
  );
}
